import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Accordion, Alert, Badge, Button, Col, Container, Form, Image, InputGroup, ListGroup, Nav, Navbar, NavDropdown, NavItem, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import MuiButton from '@mui/material/Button'
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { useTranslation } from 'react-i18next';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import { LanguageCtx, LoginInfo, NoticeList, SearchList } from '../App';
import { isLoggin, logout } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category'
import SettingPopup from './SettingPopup';
import Dialog from './Dialog';
import RegistOrLogin from './RegistOrLogin';
import { imageUrl } from '../service/CommonUtil';
import UserMark from './UserMark';
import { getOdai } from '../service/OdaiService';
import { Chip, useMediaQuery, useTheme } from '@mui/material';
import CommonDialog from './common/CommonDialog';
import Constants from './common/Constants';
import FavoriteIconMui from '@mui/icons-material/Favorite';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import {
    CalendarMonth as CalendarMonthIcon,
    Assessment as AssessmentIcon,
    BlurOn as MosaicIcon
} from '@mui/icons-material/';
import MediaSelectDialog from './generate/MediaSelectDialog';
import { PostManagementDialog } from './upload/PostManagementDialog';
import SideMenu from './common/SideMenu';
import Popover from '@mui/material/Popover';
import AppsIcon from '@mui/icons-material/Apps';
import { Calendar } from 'lucide-react';

const Header = (props) => {
    async function getNoticeList(page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/notice/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function checkNoticeList(ids){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/notice/",{ids:ids}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function checkAll(statusReason){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/checkAll",{statusReason:statusReason}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function manageBilling(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/checkout/manageBilling").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getCoin(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/balance/").then((r)=>{
            return r.json()
        })
    }
    function getRegistrationByDay(stockCode){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/data/"+stockCode).then((r)=>{
            return r.json()
        })
    }
    async function getMessage(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/info").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    
    async function refererUser(displayIdOrUserId){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/referrer",{displayIdOrUserId:displayIdOrUserId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const {t,i18n} = useTranslation()

    const navigate = useNavigate()
    const location = useLocation()
    const isHome = location.pathname === '/';

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // メッセージ一覧
    const [messageList,setMessageList] = useState([])
    const [tabKey,setTabKey] = useState("notice")
    // 言語設定
    const {language,setLanguage} = useContext(LanguageCtx)
    // 通知情報
    const {noticeList, setNoticeList} = useContext(NoticeList);
    const [noticePage, setNoticePage] = useState(1);
    const [noticeFirst, setNoticeFirst] = useState(true);
    const [noticeListDisp,setNoticeListDisp] = useState(false)
    const [loadingNotice,setLoadingNotice] = useState(false)
    const [showSetting,setShowSetting] = useState(false)
    const [coin, setCoin] = useState(0)
    // 生成機能選択
    const [openGeneratePanel,setOpenGeneratePanel] = useState(false)
    // 管理機能選択
    const [openManagePanel,setOpenManagePanel] = useState(false)
    // 検索結果情報
    const {searchResultList,setSearchResultList,searchPage,setSearchPage} = useContext(SearchList)
    const param = useParams()
    let keyword = param.keyword
    let tag = param.tag

    // 通知遅延ロード
    const options = {
        root: null,
        rootMargin: "1000px",
        threshold: 0.05
    }

    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                // imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (noticePage * 100 - 1) ){
                    setNoticePage(noticePage+1)
                }
            }
        })
    }, options);

    // キーワードとタグの変更を検出して検索窓に反映する
    useEffect(()=>{
        const keywordElement = document.getElementById("keyword");
        if(keywordElement) {
            if(keyword){
                keywordElement.value = keyword
            } else if(tag){
                keywordElement.value = "#" + tag
            }
        }
    },[keyword,tag])

    useEffect(() => {
        if(props.setting){
            setShowSetting(true)
        }
    },[props.setting])

    // param.af=displayIdOrUserIdがある場合はアフィリエイトのパラメータを設定
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const affiliateParam = params.get("af");
        if (affiliateParam) {
            refererUser(affiliateParam).then(r => {})
        }
    }, []);

    // 初回マウント時の言語設定
    useEffect(() => {
        // ログイン情報がまだ取得されていない場合の初期言語設定
        if (!loginInfo || loginInfo.length === 0) {
            const savedLang = localStorage.getItem("language");
            if (!savedLang || !["ja", "en", "zhtw", "zhCN", "ko"].includes(savedLang)) {
                setBrowserLanguage();
            }
        }
    }, []); // 初回マウント時のみ実行

    // ブラウザ言語に基づいて言語を設定する関数
    const setBrowserLanguage = () => {
        const browserLang = window.navigator.language || window.navigator.languages[0];
        let targetLang = "en"; // デフォルトは英語
        
        if (browserLang.startsWith("ja")) {
            targetLang = "ja";
        } else if (browserLang.startsWith("zh-TW") || browserLang.startsWith("zh-Hant")) {
            targetLang = "zhtw";
        } else if (browserLang.startsWith("zh-CN") || browserLang.startsWith("zh-Hans") || browserLang.startsWith("zh")) {
            targetLang = "zhCN";
        } else if (browserLang.startsWith("ko")) {
            targetLang = "ko";
        } else if (browserLang.startsWith("en")) {
            targetLang = "en";
        }
        
        localStorage.setItem("language", targetLang);
        i18n.changeLanguage(targetLang);
        setLanguage(targetLang);
        
        return targetLang;
    };

    useEffect(()=>{
        // ログイン情報取得
        if(!loginInfo || loginInfo.length === 0){
            isLoggin().then(json => {
                setLoginInfo(json)
                if(json && json.result){
                    // ログインしている場合はサーバーから取得した言語を使用
                    i18n.changeLanguage(json.language)
                    setLanguage(json.language)
                } else {
                    // ログインしていない場合の言語設定処理
                    let s = localStorage
                    let l = s.getItem("language")
                    
                    // ローカルストレージに言語設定がある場合はそれを使用
                    if(l !== null && ["ja", "en", "zhtw", "zhCN", "ko"].includes(l)){
                        i18n.changeLanguage(l)
                        setLanguage(l)
                    } else {
                        // ローカルストレージにない場合はブラウザ言語を使用
                        setBrowserLanguage();
                    }
                }
            })
            // メッセージ取得
            getMessage().then(r=>{
                if(r && r.result){
                    setMessageList(r.data)
                }
            })
        }
    },[loginInfo])

    // 通知情報
    useEffect(() => {
        if(loginInfo && loginInfo.length !== 0){
            if(noticeListDisp || noticeFirst){
                setLoadingNotice(true)
                getNoticeList(noticePage).then(json=>{
                    if(json && json.result){
                        if(json.data && json.data.length > 0){
                            if(noticePage === 1){
                                setNoticeList(json.data)
                            } else {
                                setNoticeList(prevNoticeList => (prevNoticeList || []).concat(json.data))
                            }
                            setNoticeFirst(false)
                        }
                    }
                    setLoadingNotice(false)
                })
            } else {
                // 通知を閉じた場合は一覧削除
                setNoticePage(1)
                setNoticeList([])
            }
        }
    },[loginInfo,noticeListDisp,noticePage])

    useEffect(() => {
        const rootElement = document.querySelector("#root");
        if(rootElement){
            if(noticeListDisp){
                document.querySelectorAll("#root").forEach(e => e.classList.add("touchnone"))
                // メッセージ取得
                getMessage().then(r=>{
                    if(r && r.result){
                        setMessageList(r.data)
                    }
                })
            } else {
                document.querySelectorAll("#root").forEach(e => e.classList.remove("touchnone"))
            }
        }
    },[noticeListDisp])

    // 通知遅延ロード
    useEffect(() => {
        document.querySelectorAll(".noticeLazy").forEach(e => observer.observe(e))
    },[noticeList])

    const [odai,setOdai] = useState()
    const [currentValue,setCurrentValue] = useState(0)
    const [yesterdayValue,setYesterdayValue] = useState(0)
    const [hikaku,setHikaku] = useState(0)
    const [hikakuStr,setHikakuStr] = useState(0)
    const [per,setPer] = useState("")
    const [perStr,setPerStr] = useState("")
    const [stockName,setStockName] = useState("")
    useEffect(() => {
        // お題
        getOdai().then(r => {
            if(r.result && r.data.length > 1){
                setOdai(r.data[0].odai)
            }
        })
        getRegistrationByDay("1000").then(r => {
            if(r.result){
                setCurrentValue(r.data.today_value)
                let hikaku = r.data.today_value - r.data.yesterday_value
                let per = hikaku / r.data.yesterday_value * 100
                per = Math.floor(per * 100) / 100
                let perStr = per

                if(per > 0){
                    perStr = "+" + per
                }
                setPer(per)
                setPerStr(perStr)
                let hikakuStr = hikaku
                if(hikaku > 0){
                    hikakuStr = "+" + hikaku.toLocaleString()
                } else {
                    hikakuStr = hikaku.toLocaleString()
                }
                setHikaku(hikaku)
                setHikakuStr(hikakuStr)
                setStockName(r.data.stock_name)
            }
        })
    },[])

    let loginButton
    let accountArea = ""
    let noticeArea = ""
    let registButton = ""
    if(!loginInfo || loginInfo.length === 0 || loginInfo.result === false){
        registButton = <Chip color="info" onClick={() => dialog("",<RegistOrLogin dialog={dialog} />)} label={t("login.login")} />
        loginButton = ""
    } else {
        accountArea = 
        <NavDropdown onToggle={(open) => {
            if(open && loginInfo && loginInfo.result){
                getCoin().then(r => {
                    if(r && r.result){
                        setCoin(r.data ? r.data.balance : 0)
                    }
                })
            }
        }} title={(
            <span style={{position:"relative",display:"inline-block",width:"38px",height:"38px"}}>
                <Image width="38px" height="38px" style={{borderRadius:"19px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+(loginInfo ? loginInfo.userId : "")+"_s.jpg?"+(loginInfo ? loginInfo.hash : "")}/>
            </span>
        )} id="basic-nav-dropdown">
            {/*<NavDropdown.Item as={Link} to={"https://sns.ourt-ai.work/"} target='_blank'><Icon.ChatText /> {t("common.timeline")}</NavDropdown.Item>*/}
            {loginInfo && loginInfo.result ? <LinkContainer to={"/coin"}><NavDropdown.Item>{Constants.CURRENCY_UNIT_LEFT_COIN} {coin === 0 ? "コイン管理" : coin.toLocaleString()}</NavDropdown.Item></LinkContainer> : ""}
            <LinkContainer to={"/user/"+((loginInfo && loginInfo.displayId !== "" && loginInfo.displayId) ? loginInfo.displayId : (loginInfo ? loginInfo.userId : ""))}><NavDropdown.Item><Icon.Person /> {t("category.mypage")}</NavDropdown.Item></LinkContainer>
            <LinkContainer to={"/rewards"}><NavDropdown.Item><Icon.Gift /> 特典応募</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/stampManage"><NavDropdown.Item><RIcon.FaStamp /> {t("category.stampManage")}</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/favorite"><NavDropdown.Item><Icon.HandThumbsUp /> {t("category.favorite")}</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/history"><NavDropdown.Item><RIcon.FaHistory /> {t("category.browsingHistory")}</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/generatedHistory/image"><NavDropdown.Item><RIcon.FaHistory /> {t("category.generatedHistory")}</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/invest"><NavDropdown.Item><RIcon.FaMoneyBill /> {t("common.pointManagement")}</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/affiliate/dashboard"><NavDropdown.Item><Icon.CashStack /> アフィリエイト報酬</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/pointHistory"><NavDropdown.Item><Icon.ListColumns /> {t("common.pointHistory")}</NavDropdown.Item></LinkContainer>
            {/*<LinkContainer to="/setting"><NavDropdown.Item><Icon.GearWide /> {t("category.setting")}</NavDropdown.Item></LinkContainer>*/}
            <NavDropdown.Item className='d-none' onClick={() => {
                navigate("/manage/payouts")
            }}><RIcon.FaMoneyBill /> {t("common.managePayouts")}</NavDropdown.Item>
            <NavDropdown.Item onClick={() => {
                navigate("/manageBilling")
            }}><RIcon.FaStar /> {t("common.manageBilling")}</NavDropdown.Item>
            <NavDropdown.Item onClick={() => {
                navigate("/manage/payouts")
            }}><RIcon.FaMoneyCheck /> 支援・売上金管理</NavDropdown.Item>
            <NavDropdown.Item onClick={() => {
                navigate("/user/"+((loginInfo && loginInfo.displayId !== "" && loginInfo.displayId) ? loginInfo.displayId : (loginInfo ? loginInfo.userId : "")) + "/plans")
            }}><RIcon.FaMoneyCheck /> プラン管理</NavDropdown.Item>
            <NavDropdown.Item onClick={() => {
                setShowSetting(true)
            }}><Icon.GearWide /> {t("category.setting")}</NavDropdown.Item>
            <NavDropdown.Item onClick={() => {
                logout(setLoginInfo)
                window.location.href = "/"
            }}>{t("header.logout")}</NavDropdown.Item>
            <NavDropdown.Divider />
            <Container className='text-center'>
                <Link to={"https://lin.ee/9JVODFH"}  target='_blank' style={{fontSize:"28px",textDecoration:"none"}}><Icon.Line /></Link>
                &nbsp;&nbsp;
                <Link to={"//x.com/ourt_ai"} target='_blank' style={{fontSize:"28px",textDecoration:"none"}}>𝕏</Link>
                &nbsp;&nbsp;
                <Link to={"//discord.gg/DTsR7gnf6x"} target='_blank' style={{fontSize:"28px"}}><Icon.Discord /></Link>
                &nbsp;&nbsp;
                <Link to={"//sns.ourt-ai.work"} target='_blank' style={{fontSize:"30px"}}><Image src="/img/misskey.png" width="30px" /></Link>
            </Container>
        </NavDropdown>  
        noticeArea =
        <div>
            <div style={{cursor:"pointer"}} onClick={() =>{
                // 通知を確認済に更新                
                if(noticeList && noticeList.length > 0) {
                    checkNoticeList(noticeList.map(d => d.id))
                }
                // 通知一覧を表示
                setNoticeListDisp(!noticeListDisp)
            }}>
                <span style={{position:"relative"}}>
                    <Icon.Bell style={{position:"relative",fontSize:"24px"}} id="bell" />
                    {noticeList && noticeList.filter(d => d.checked === 0).length > 0 ? (<Badge bg="danger" style={{position:"absolute",top:"-5px",right:"-10px"}}>{noticeList.filter(d => d.checked === 0).length > 9 ? "9+" : noticeList.filter(d => d.checked === 0).length}</Badge>) : ""}
                </span>
            </div>
            {noticeListDisp ? (() => {
                const bellElement = document.querySelector("#bell");
                const bellRect = bellElement ? bellElement.getBoundingClientRect() : null;
                const leftPosition = bellRect && bellRect.x <= 360 ? 0 : 
                    (bellRect ? bellRect.x - 340 - (isLargeScreen && isHome ? 280 : 0) : 0);
                
                return (<ListGroup id='notice-list' style={{position:"absolute",width:"360px",height:"540px",overflow:"auto",marginTop:"18px",left: leftPosition ,zIndex:3}}>
                <ListGroup.Item className="p-0">
                    <Tabs defaulltActiveKey={"notice"} activeKey={tabKey} onSelect={(e)=>setTabKey(e)}>
                        <Tab eventKey={"notice"} title="通知"></Tab>
                        <Tab eventKey={"system"} title="お知らせ"></Tab>
                    </Tabs>
                    {tabKey === "notice" ? (
                    <LinkContainer to={"/notice"} className="list-item p-1">
                        <Container className="d-flex p-3">
                            <Container style={{width:"50px"}} className='m-0'><Icon.Bell style={{width:"30px",height:"30px",borderRadius:"15px"}} /></Container>
                            <div>
                                <Container>{t("common.notificationList")}</Container>
                            </div>
                        </Container>
                    </LinkContainer>) : ""}
                </ListGroup.Item>
                {tabKey === "notice" && noticeList && noticeList.map((d,i)=>{
                    let link
                    if(d.type==="follow"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#fff8f0", borderLeft: "4px solid #f6ad55"}}>
                                <LinkContainer to={"/user/"+d.user_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px",display:"flex",alignItems:"center",position:"relative"}}>
                                            <Link to={"/user/"+d.user_id}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" /></Link>
                                            <Icon.PersonPlus style={{position:"absolute",bottom:"-5px",right:"-5px",backgroundColor:"#f6ad55",color:"white",borderRadius:"50%",padding:"2px",fontSize:"16px"}} />
                                        </Container>
                                        <Container>
                                            <Container>{t("notice.followedLeftText")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.followedRightText")}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "favorite_image" || d.type === "favorite_text"){
                        let type = d.type.startsWith("favorite_image") ? "image" : "text"
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#fff5f5", borderLeft: "4px solid #f56565"}}>
                                <LinkContainer to={"/"+type+"/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px",display:"flex",alignItems:"center",position:"relative"}}>
                                            <Link to={"/user/"+d.user_id}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" /></Link>
                                            <Icon.Heart style={{position:"absolute",bottom:"-5px",right:"-5px",backgroundColor:"#f56565",color:"white",borderRadius:"50%",padding:"2px",fontSize:"16px"}} />
                                        </Container>
                                        <Container>
                                            <Container>{t("notice.favoriteLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.favoriteCenter")}「<b>{d.title}</b>」{t("notice.favoriteRight")}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "favorite_community"){
                        link = 
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#fff5f5", borderLeft: "4px solid #f56565"}}>
                                <LinkContainer to={"/post/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px",display:"flex",alignItems:"center",position:"relative"}}>
                                            <Link to={"/user/"+d.user_id}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" /></Link>
                                            <Icon.Heart style={{position:"absolute",bottom:"-5px",right:"-5px",backgroundColor:"#f56565",color:"white",borderRadius:"50%",padding:"2px",fontSize:"16px"}} />
                                        </Container>
                                        <Container>
                                            <Container>{t("notice.favoriteLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.favoriteCenter")}「<b>{d.title}</b>」{t("notice.favoriteRight")}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "image_reply"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0f8ff", borderLeft: "4px solid #4a90e2"}}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px",display:"flex",alignItems:"center",position:"relative"}}>
                                            <Link to={(d.comment === "is_character" ? "/character/" : "/user/") + d.user_id}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+(d.comment === "is_character" ? ("/character/post/t/"+d.user_id+"_in.webp") : ("/profile/"+d.user_id+"_s.jpg"))} className="noticeLazy" /></Link>
                                            <Icon.ChatDots style={{position:"absolute",bottom:"-5px",right:"-5px",backgroundColor:"#4a90e2",color:"white",borderRadius:"50%",padding:"2px",fontSize:"16px"}} />
                                        </Container>
                                        <Container>
                                            <Container>{t("notice.commentLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.commentCenter")}「<b>{d.title}</b>」{t("notice.commentRight")}</Container>
                                            {d.comment.length > 0 && d.comment !== "is_character" ? <Container>「{d.comment}」</Container> : ""}
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "image_reply_sub"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0f8ff", borderLeft: "4px solid #4a90e2"}}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px",display:"flex",alignItems:"center",position:"relative"}}>
                                            <Link to={(d.comment === "is_character" ? "/character/" : "/user/") + d.user_id}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+(d.comment === "is_character" ? ("/character/post/t/"+d.user_id+"_in.webp") : ("/profile/"+d.user_id+"_s.jpg"))} className="noticeLazy" /></Link>
                                            <Icon.ChatDots style={{position:"absolute",bottom:"-5px",right:"-5px",backgroundColor:"#4a90e2",color:"white",borderRadius:"50%",padding:"2px",fontSize:"16px"}} />
                                        </Container>
                                        <Container>
                                            <Container>{t("notice.commentSubLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.commentSubCenter")}「<b>{d.title}</b>」{t("notice.commentSubRight")}</Container>
                                            {d.comment.length > 0 && d.comment !== "is_character" ? <Container>「{d.comment}」</Container> : ""}
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "community_reply"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0f8ff", borderLeft: "4px solid #4a90e2"}}>
                                <LinkContainer to={"/post/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px",display:"flex",alignItems:"center",position:"relative"}}>
                                            <Link to={"/user/"+d.user_id}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" /></Link>
                                            <Icon.ChatDots style={{position:"absolute",bottom:"-5px",right:"-5px",backgroundColor:"#4a90e2",color:"white",borderRadius:"50%",padding:"2px",fontSize:"16px"}} />
                                        </Container>
                                        <Container>
                                            <Container>{t("notice.commentLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.commentCenter")}「<b>{d.title}</b>」{t("notice.commentRight")}</Container>
                                            {d.comment.length > 0 ? <Container>「{d.comment}」</Container> : ""}
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "ranking"){
                        let styles = [t("common.illustration"),t("common.photorealistic"),t("common.semirealism")]
                        let styleParams = ["illustration","photorealistic","semirealism"]
                        let categoryList = [t("common.allAges"),"PG-12","R-18","R-18G",t("common.all")]
                        let categoryParams = {"allAges":t("common.allAges"),"pg12":"PG-12","r15":"R-15","r18":"R-18","r18g":"R-18G","all":"総合"}
                        let typeList = ["すべて","お題","お題除外"]
                        let typeParams = ["s_all","s_odai","s_jogai"]
                        let styleNo = 0
                        let general = ""
                        let typeNo = 0
                        let typeStr = ""
                        let rankStr = ""
                        if(d.comment.indexOf(",") !== -1){
                            let spl = d.comment.split(",")
                            typeNo = parseInt(spl[1]) -1
                            typeStr = typeList[typeNo]
                            rankStr = spl[0]
                        } else {
                            typeStr = typeList[0]
                            rankStr = d.comment
                        }
                        if(d.user_name.indexOf(":") !== -1){
                            let spl = d.user_name.split(":")
                            styleNo = parseInt(spl[0]) - 1
                            general = spl[1]
                        } else {
                            styleNo = 1
                            general = d.user_name
                        }
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/ranking/"+styleParams[styleNo]+"/"+general.replace("allAges","all")+"/1day/"+typeParams[typeNo]+"/1"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in.webp"} className="noticeLazy" /></Container>
                                        <Container>
                                            <Container>{t("notice.rankingLeft")}「{d.title}」{t("notice.rankingCenter")}<b>{rankStr}</b>{t("notice.rankingRight")}</Container>
                                            <Container>{typeStr} {styles[styleNo]} {categoryParams[general]} {d.ymd}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "age_limit_alert"){
                        let ageLimitList = [t("common.allAges"),"PG-12","R-15","R-18","R-18G",t("common.all")]
                        let sexualExpressionList = [t("upload.image.whatIsSexual"),""]
                        let spl = d.comment.split("->")
                        let oldSpl = spl[0].split(",")
                        let newSpl = spl[1].split(",")
                        let oldAgeLimit = oldSpl[0]
                        let oldSexualExpression = oldSpl[1]
                        let newAgeLimit = newSpl[0] - 1
                        let newSexualExpression = newSpl[1]
                        console.log(oldAgeLimit,oldSexualExpression,newAgeLimit,newSexualExpression)

                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in.webp"} className="noticeLazy" /></Container>
                                        <Container>
                                            <Container style={{color:"red"}}>{t("notice.ageLimitAlert")}</Container>
                                            <Container>「{d.title}」</Container>
                                            <Container>{ageLimitList[newAgeLimit]}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "mosaic_alert" || d.type === "child_porn_alert"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/"+d.comment+"/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}>
                                            {d.comment === "video" ? (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id,"status":5},d.comment)} className="noticeLazy" />
                                            ) : (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id},d.comment)} className="noticeLazy" />
                                            )}
                                        </Container>
                                        <Container>
                                            <Container style={{color:"red"}}>{d.type === "mosaic_alert" ? t("notice.mosaicAlert") : t("notice.childPornAlert")}</Container>
                                            <Container>「{d.title}」</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "problem_result"){
                        // 再公開
                        if(d.user_name === "1"){
                            link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/"+d.comment+"/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}>
                                            {d.comment === "video" ? (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id,"status":5},d.comment)} className="noticeLazy" />
                                            ) : (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id},d.comment)} className="noticeLazy" />
                                            )}
                                        </Container>
                                        <Container>
                                            <Container style={{color:"green"}}><Icon.CheckCircle /> 審査の結果、再公開されました。</Container>
                                            <Container>「{d.title}」</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                        } else if(d.user_name === "2"){
                            // 差し戻し
                            link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/"+d.comment+"/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}>
                                            {d.comment === "video" ? (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id,"status":5},d.comment)} className="noticeLazy" />
                                            ) : (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id},d.comment)} className="noticeLazy" />
                                            )}
                                        </Container>
                                        <Container>
                                            <Container style={{color:"red"}}><Icon.XCircle /> 審査の結果、差し戻されました：{d.user_name === "1" ? t("notice.mosaicAlert") : t("notice.childPornAlert")}</Container>
                                            <Container>「{d.title}」</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                        }
                    } else if(d.type === "point_send"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0fff0", borderLeft: "4px solid #28a745"}}>
                                <LinkContainer to={"/user/"+d.user_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px",display:"flex",alignItems:"center",position:"relative"}}>
                                            <Link to={"/user/"+d.user_id}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" /></Link>
                                            <Icon.GiftFill style={{position:"absolute",bottom:"-5px",right:"-5px",backgroundColor:"white",borderRadius:"50%",padding:"2px",fontSize:"16px",color:"#28a745"}} />
                                        </Container>
                                        <Container>
                                            <Container>{t("notice.pointSendLeft")}{d.user_name}<UserMark plan={d.plan}/>{t("notice.pointSendRight")}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "report"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/siteManage"} className="list-item p-1" style={{color:"red"}}>
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>新しい通報がありました。内容を確認してください。</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "monetization"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <Container className="d-flex p-0">
                                    <Container>
                                        <Container>🎉収益が送金されました。+{d.comment} 円</Container>
                                        <Container>{d.create_datetime}</Container>
                                    </Container>
                                </Container>
                            </ListGroup.Item>
                    } else if(d.type === "outside_id_link_world_id"){
                        let point = parseInt(d.comment).toLocaleString()
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <Container className="d-flex p-0">
                                    <Container>
                                        <Container>🎉World ID連携ボーナスの生成ポイントが付与されました。+{point} ポイント</Container>
                                        <Container>{d.create_datetime}</Container>
                                    </Container>
                                </Container>
                            </ListGroup.Item>
                    } else if(d.type === "coinCharge"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <Container className="d-flex p-0">
                                    <Container>
                                        <Container>コインがチャージされました。 {Constants.CURRENCY_UNIT_LEFT_COIN} {parseInt(d.comment).toLocaleString()}</Container>
                                        <Container>{d.create_datetime}</Container>
                                    </Container>
                                </Container>
                            </ListGroup.Item>
                    } else if(d.type === "id_regist"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/manage/id"} className="list-item p-1" style={{color:d.comment !== "" ? "red" : ""}}>
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>{d.comment === "" ? "身分証確認が完了しました。" : "身分証確認が差し戻されました。"}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "fanart"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        {/*<Container style={{width:"75px",height:"75px",overflow:"hidden"}}><Image data-no={i} loading="lazy" style={{width:"75px",height:"75px",filter:"blur(10px)"}} src={"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in.webp"} className="noticeLazy" /></Container>*/}
                                        <FavoriteIconMui style={{color:"red"}} />
                                        <Container>
                                            <Container>「{d.title}」</Container>
                                            <Container>{t("common.fanartPosted")}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "dividend"){
                        let point = parseInt(d.comment).toLocaleString()
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/pointHistory/"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>🎉ポイント運用で配当がありました。</Container>
                                            <Container>配当額：{point} ポイント</Container>
                                            <Container>銘柄：{d.title}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "zero_point_campaign"){
                        let point = parseInt(d.comment).toLocaleString()
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/pointHistory/"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>🎉キャンペーン参加特典が付与されました。</Container>
                                            <Container>{point} ポイント</Container>
                                            <Container>{d.title}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "rewards_delivery"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/rewardsHistory/"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>🎉{d.title}</Container>
                                            <Container>{d.comment}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    }
                    return link
                })}
                {tabKey === "system" ? (<>
                    {messageList.map((d,i) => {
                        let isLink = d.url.length > 0
                        return <ListGroup.Item className="p-0" key={i}>
                            <Container className="d-flex p-0" style={{cursor:isLink ? "pointer" : "none"}} onClick={() => {
                                if(isLink){
                                    navigate(d.url)
                                }
                            }}>
                                <Container>
                                    <Container>{d.text}</Container>
                                    <Container>{d.release_datetime}</Container>
                                </Container>
                            </Container>
                        </ListGroup.Item>
                    })}
                </>) : ""}
                {loadingNotice ? (
                <ListGroup.Item className="p-1">
                    <Container className="text-center">
                        <Container>
                            <Container><Spinner animation="border" size="lg" /> </Container>
                        </Container>
                    </Container>
                </ListGroup.Item>
                ) : ""}
            </ListGroup>);
            })() : ""}
        </div>
    }

    const [searchArea,setSearchArea] = useState(false)
    function changeLanguage(lang){
        let s = localStorage
        s.removeItem("language")
        s.setItem("language",lang)
        i18n.changeLanguage(lang)
        setLanguage(lang)
    }
    const [terms,setTerms] = useState("")
    const [guideline,setGuideline] = useState("")
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getGuideline(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/guideline").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [mode, setMode] = useState("post")
    // アプリアイコン用 state
    const [appAnchorEl, setAppAnchorEl] = useState(null);
    const handleAppIconClick = (event) => {
        setAppAnchorEl(event.currentTarget);
    };
    const handleAppClose = () => {
        setAppAnchorEl(null);
    };
    const appOpen = Boolean(appAnchorEl);

    return (<>
    <div>
        <MediaSelectDialog
            open={openGeneratePanel}
            onClose={() => setOpenGeneratePanel(false)}
            onSelectSimpleImage={() => navigate("/generate/image/simple")}
            onSelectImage={() => window.location.href = "/upload/image/generate"}
            onSelectVideo={() => navigate("/generate/video")}
            onSelectAudio={() => navigate("/generate/voice")}
        />
        <PostManagementDialog
            open={openManagePanel}
            onClose={() => setOpenManagePanel(false)}
        />
        <SideMenu />
        <CommonDialog open={show}
            content={dialogMessage}
            onClick={() => {
                setShow(false)
            }} onClose={() => setShow(false)}
            title={dialogTitle} />
        {showSetting ? (<SettingPopup switch={setShowSetting} />) : ""}
        <Row style={{position:"fixed",top:0,zIndex:3,width:isLargeScreen && isHome ? window.innerWidth - 280 : "100%",boxShadow:"1px 1px 5px #EEEEEE",backgroundColor:"#FFFFFF"}} className="m-0 mt-1">
            {loginInfo && loginInfo.result && (loginInfo.status === 1 || loginInfo.status === 2) ? (
                <Alert variant='info' className='text-center'>このアカウントは削除されました。</Alert>
            ) : ""}
            {loginInfo && loginInfo.result && loginInfo.status === 3 ? (
                <Alert variant='info' className='text-center'>
                    <Container className='text-center'>
                        {t("common.accountTemporarilySuspended")} {loginInfo.status_reason === 1 ? <>{t("common.reason") + ":" + t("common.violationOfTermsOfService")}<br /></> : "" }
                        {loginInfo.status_reason === 2 ? <>{t("common.reason") + ":" + t("common.childPornographyPosts")}<br /></> : "" }
                        {loginInfo.status_reason === 3 ? <>{t("common.reason") + ":" + t("common.generationOfChildPornography")}<br /></> : "" }
                        {loginInfo.status_reason === 4 ? <>{t("common.reason") + ":" + t("common.copyrightInfringement")}<br /></> : "" }
                        {loginInfo.status_reason === 5 ? <>{t("common.reason") + ":" + t("common.suspiciousOperation")}<br /></> : "" }
                        {loginInfo.status_reason >= 1 && loginInfo.status_reason <= 5 ? (
                            <>
                                {t("common.plaseReviewTermsAndGuidelines")}<br />
                                <Button variant='secondary' className='m-1'
                                    onClick={() => {
                                        getTerms().then(r => {
                                            if(r.result){
                                                setTerms(r.text)
                                                dialog("",<Container className='w-100' dangerouslySetInnerHTML={{__html: r.text}} />)
                                            }
                                        })
                                    }}
                                >{t("common.termsOfService")}</Button>
                                <Button variant='secondary' style={{marginLeft:"10px"}} className='m-1'
                                    onClick={() => {
                                        getGuideline().then(r => {
                                            if(r.result){
                                                setGuideline(r.text)
                                                dialog("",<Container className='w-100' dangerouslySetInnerHTML={{__html: r.text}} />)
                                            }
                                        })
                                    }}
                                >{t("common.guideline")}</Button><br />
                                <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}}>
                                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} id="read-terms" onChange={(e) => {
                                        
                                    }} />
                                    <Form.Control type="text" value={t("common.checkedTerms")} readOnly />
                                </InputGroup>
                                <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}}>
                                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} id="read-guideline" onChange={(e) => {
                                        
                                    }} />
                                    <Form.Control type="text" value={t("common.checkedGuideline")} readOnly />
                                </InputGroup>
                                <Button variant='danger'
                                onClick={() => {
                                    let terms = document.querySelector("#read-terms")
                                    let guideline = document.querySelector("#read-guideline")
                                    if(terms.checked && guideline.checked){
                                        checkAll(loginInfo.status_reason).then(r => {
                                            if(r.result){
                                                window.location.reload()
                                            } else {
                                                dialog(t("common.error"),r.errors)
                                            }
                                        })
                                    } else {
                                        dialog(t("common.confirm"),t("common.pleaseCheckAll"))
                                    }
                                }}
                                >{t("common.understand")}</Button>
                            </>
                        ) : ""}
                    </Container>
                </Alert>
            ) : ""}
            {loginInfo && loginInfo.result && loginInfo.status === 4 ? (
                <Alert variant='info' className='text-center'>
                    {t("common.accountPermanentlyFrozen")}
                </Alert>
            ) : ""}
            <Col xs={4} sm={4} md={3} lg={2} xl={2} xxl={3} style={{display:searchArea ? "none" : "block"}}>
                <span style={{display:"none",fontSize:"1.5em",cursor:"pointer",marginRight:"1em"}} onClick={() => {
                    let menu = document.getElementById("menu")
                    menu.style.transition = "0.1s"
                    if(menu.style.display === "block"){
                        menu.style.display = "none"
                    } else {
                        menu.style.display = "block"
                    }
                }}><Icon.List style={{border:"1px solid #000000"}} /></span>
                {!loginInfo || loginInfo.result === undefined || isLargeScreen ? "" : (<>
                    {loginInfo && loginInfo.kawaii_mode === 1 ? "kawaii" : (
                    <Link to="/" style={{textDecoration:"none",color: "#000000"}}><span className="App-logo d-none d-sm-inline-block" id="logo" style={{fontSize:"18px",cursor:"pointer",marginLeft:"48px"}}><img src='/img/logo_new.png' height={18} /></span> <span className='d-none d-sm-inline-block' style={{fontSize:"8px"}}>JP</span></Link>
                    )}
                    </>
                )}
            </Col>
            <Col className="d-block d-lg-none" xs={1} sm={1} style={{position:"relative"}}>
                <Icon.Search className='mt-2' style={{fontSize:"24px",cursor:"pointer",display:searchArea ? "none" : "block"}} onClick={() => setSearchArea(true)} />
                {searchArea ? (
                <>
                <div style={{position:"fixed",top:"30px",left:0,zIndex:2,width:"100%"}}>
                    <InputGroup>
                        <InputGroup.Text style={{cursor:"pointer"}} onClick={() => setSearchArea(false)}><Icon.ArrowLeft /></InputGroup.Text>
                        <InputGroup.Text><Icon.Search /></InputGroup.Text>
                        <Form.Control
                            id="keyword"
                            placeholder='イラスト名、ユーザ名など'
                            aria-label="keyword"
                            aria-describedby="basic-addon1"
                            defaultValue={keyword ? keyword : tag ? "#" + tag : ""}
                            onKeyDown={(e)=>{
                                const keywordElement = document.getElementById("keyword");
                                let keyword = keywordElement ? keywordElement.value : "";
                                if(e.key === "Enter" && keyword.trim().length > 0){
                                    if(keyword.startsWith("#")){
                                        navigate("/tag/"+keyword.replace("#","")+"/1")
                                    } else {
                                        console.log(keyword)
                                        setSearchPage(1)
                                        navigate("/search/"+keyword+"/1")
                                    }
                                }
                                
                            }}
                            autoComplete="new-password"
                        />
                        <Button onClick={() => {
                            const keywordElement = document.getElementById("keyword");
                            let keyword = keywordElement ? keywordElement.value : "";
                            if(keyword.trim().length > 0){
                                if(keyword.startsWith("#")){
                                    navigate("/tag/"+keyword.replace("#","")+"/1")
                                } else {
                                    setSearchPage(1)
                                    navigate("/search/"+keyword+"/1")
                                }
                            }
                        }}>検索</Button>
                    </InputGroup>
                </div>
                </>
                ) : ""}
            </Col>
            <Col className="d-none d-lg-block" lg={6} xl={6} xxl={6}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    {!searchArea ? (
                    <InputGroup>
                        <LinkContainer to={"/odai"} style={{fontSize:"12px"}} className='m-1 p-1 d-none d-xl-block'><MuiButton>お題「{odai}」</MuiButton></LinkContainer>
                        {/*<MuiButton onClick={() => navigate("/")} style={{fontSize:"12px"}}>{t("category.home")}</MuiButton>*/}
                        <MuiButton onClick={() => navigate("/search_characters")} style={{fontSize:"12px"}}>キャラクター</MuiButton>
                        <MuiButton onClick={() => navigate("/search_users")} style={{fontSize:"12px"}}>クリエイター</MuiButton>
                        <MuiButton onClick={() => navigate("/ranking")} style={{fontSize:"12px"}}>ランキング</MuiButton>
                        <MuiButton onClick={() => navigate("/invest")} style={{fontSize:"12px"}}><RIcon.FaChartLine />&nbsp;{currentValue.toLocaleString()}&nbsp;<span style={{color:per >= 0 ? "red" : "blue"}}>{perStr}%</span></MuiButton>
                        <Form.Control
                            id="keyword"
                            placeholder={t("header.searchLabel")}
                            aria-label="keyword"
                            aria-describedby="basic-addon1"
                            defaultValue={keyword ? keyword : tag ? "#" + tag : ""}
                            onKeyDown={(e)=>{
                                const keywordElement = document.getElementById("keyword");
                                let keyword = keywordElement ? keywordElement.value : "";
                                if(e.key === "Enter" && keyword.trim().length > 0){
                                    if(keyword.startsWith("#")){
                                        navigate("/tag/"+keyword.replace("#","")+"/1")
                                    } else {
                                        console.log(keyword)
                                        setSearchPage(1)
                                        navigate("/search/"+keyword+"/1")
                                    }
                                }
                                
                            }}
                            autoComplete="new-password"
                        />
                        <Button onClick={() => {
                            const keywordElement = document.getElementById("keyword");
                            let keyword = keywordElement ? keywordElement.value : "";
                            if(keyword.trim().length > 0){
                                if(keyword.startsWith("#")){
                                    navigate("/tag/"+keyword.replace("#","")+"/1")
                                } else {
                                    setSearchPage(1)
                                    navigate("/search/"+keyword+"/1")
                                }
                            }
                        }}><Icon.Search /></Button>
                    </InputGroup>
                    ) : ""}
                </Col>
            </Col>
            <Col xs={7} sm={6} md={4} lg={4} xl={3} xxl={3} style={{margin:"0 auto",display:searchArea ? "none" : "flex", alignItems: 'center'}}>
                <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={4} className="d-none d-sm-block">
                <NavDropdown style={{marginTop:"4px",display:"block"}} title={(
                    <Icon.Globe style={{fontSize:"26px"}}/>
                )} id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={() => changeLanguage("ja")}>日本語</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => changeLanguage("en")}>English</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => changeLanguage("zhtw")}>中文(繁體)</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => changeLanguage("zhCN")}>中文(简体)</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => changeLanguage("ko")}>한국어</NavDropdown.Item>
                </NavDropdown>
                </Col>
                {/* アプリアイコン追加 */}
                <span 
                    className="app-icon-wrapper"
                    style={{cursor:'pointer', marginRight:'10px'}} 
                    onClick={handleAppIconClick}
                >
                    <AppsIcon style={{fontSize:32}} />
                </span>
                <Popover
                    open={appOpen}
                    anchorEl={appAnchorEl}
                    onClose={handleAppClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Container style={{padding: '16px', minWidth: '220px'}}>
                        {/* グリッド形式でアプリアイコンを表示（アイコン大・ラベル下） */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '8px',
                        }}>
                            <Chip className='p-1 m-0' title='生成' variant="outline-secondary" style={{textDecoration:"none",whiteSpace:"nowrap"}}
                                disabled={loginInfo.result === true && loginInfo.status !== 0}
                                label={<><Icon.Palette /> 生成</>} onClick={() => setOpenGeneratePanel(true)} />
                            <Chip className='p-1' title='投稿管理' variant="outline-secondary" style={{textDecoration:"none",whiteSpace:"nowrap",marginLeft:"5px"}}
                                label={<><Icon.Upload /> 投稿</>} onClick={() => setOpenManagePanel(true)} disabled={loginInfo.result === true && loginInfo.status !== 0}/>

                            <div className="app-grid-btn" onClick={()=>{navigate('/tools/calendarMemo'); handleAppClose();}}>
                                <CalendarMonthIcon style={{fontSize:32, marginBottom: 4}} />
                                <div className="app-grid-label">カレンダー</div>
                            </div>
                            <div className="app-grid-btn" onClick={()=>{navigate('/analyze'); handleAppClose();}}>
                                <AssessmentIcon style={{fontSize:32, marginBottom: 4}} />
                                <div className="app-grid-label">分析</div>
                            </div>
                            <div className="app-grid-btn" onClick={()=>{window.open('http://ourt-ai.work:8080/', '_blank'); handleAppClose();}}>
                                <MosaicIcon style={{fontSize:32, marginBottom: 4}} />
                                <div className="app-grid-label">モザイク</div>
                            </div>
                            {/* 必要に応じてサービス追加 */}
                        </div>
                    </Container>
                </Popover>
                &nbsp;
                {accountArea}&nbsp;
                {noticeArea}&nbsp;
                {registButton}&nbsp;
                {loginButton}&nbsp;
            </Col>
        </Row>
    </div>
    {/*<CampaignMessage />*/}
    <div style={{marginTop:"70px"}} />
    <style>{`
.app-grid-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px 0 8px 0;
    background: #fff;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.2s;
    user-select: none;
}
.app-grid-btn:hover {
    background: #f0f4ff !important;
}
.app-grid-label {
    font-size: 15px;
    margin-top: 2px;
    text-align: center;
    word-break: keep-all;
}
.app-icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: background-color 0.2s ease;
}
.app-icon-wrapper:hover {
    background-color: #f0f4ff;
}
`}</style>
    </>
    )

}

export default Header;